import { List, Record } from 'immutable';
import { CurrencyCode }  from './currency-code';
import { PaymentStatus } from './payment-status.enum';
import { PaymentModifier } from './payment-modifier';

const PaymentRecord = Record({
  eventPaymentId: 0,
  commissionAmount: 0,
  feeAmount: 0,
  commissionCurrency: 'USD',
  description: null,
  commissionId: null,
  fundingReferenceId: null,
  paymentReferenceId: null,
  status: null,
  createdDate: null,
  modifiedDate: null,
  createdBy: null,
  modifiedBy: null,
  eventId: 0,
  eventPaymentModifiers: null
});

export class Payment extends PaymentRecord {
  eventPaymentId: number;
  commissionAmount: number;
  feeAmount: number;
  commissionCurrency: CurrencyCode;
  description: string;
  commissionId: string;
  fundingReferenceId: string;
  paymentReferenceId: string;
  status: PaymentStatus;
  createdDate: Date;
  modifiedDate: Date;
  createdBy: string;
  modifiedBy: string;
  eventId: number;
  eventPaymentModifiers: PaymentModifier[];
}




// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/models/payment.ts